import _ from 'lodash'
import { CssContext, CompSpecificData } from '../features/componentCss.types'
import { mergeVisibilityTransformations } from '../features/commonCssData/visibilityTransformationsCompNode'

export const accumulateCssContext: (
	compId: string,
	cssContext: CssContext,
	compSpecificData?: CompSpecificData
) => CssContext = (
	compId,
	{ getParent, isInRepeater, patterns, visibilityTransformations, isMobileView },
	compSpecificData
) => {
	return {
		isMobileView,
		isInRepeater,
		getParent,
		patterns: _.merge(patterns, compSpecificData?.patterns),
		visibilityTransformations: mergeVisibilityTransformations(
			visibilityTransformations,
			compSpecificData?.visibilityTransformations
		),
	}
}
